import { SeoMetaData } from '@cms-max/cms-browser-api-client'
import { Component } from '@cms-max/medicare-api-sdk'

const createAccountSettingsBlastAnalytics = (pageName: string) =>
  ({
    page_type: 'application',
    site_section: 'account settings',
    page_name: `account settings: ${pageName}`
  } as const)

export const accountSettingsSeoMetaData: SeoMetaData[] = [
  {
    path: '/account-settings',
    blastAnalytics: createAccountSettingsBlastAnalytics('My account settings'),
    seo: {
      en: {
        title: 'My account settings | Medicare',
        description: ''
      },
      es: {
        title: 'Configuración de mi cuenta | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/account-settings/get-my-medicare-card',
    blastAnalytics: createAccountSettingsBlastAnalytics('Get my Medicare card'),
    seo: {
      en: {
        title: 'Get my Medicare card | Medicare',
        description: ''
      },
      es: {
        title: 'Conseguir mi tarjeta médica | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/account-settings/deactivate-account',
    blastAnalytics: createAccountSettingsBlastAnalytics('Delete account'),
    seo: {
      en: {
        title: 'Delete account | Medicare',
        description: ''
      },
      es: {
        title: 'Eliminar cuenta | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/account-settings/deactivate-account-success',
    blastAnalytics: createAccountSettingsBlastAnalytics(
      'Delete account success'
    ),
    seo: {
      en: {
        title: 'Success! | Medicare',
        description: ''
      },
      es: {
        title: '¡Éxito! | Medicare',
        description: ''
      }
    }
  }
].map((seoMetaData) => ({
  ...seoMetaData,
  component: Component.AccountSettings
}))
